export default [
  {
    id: 1,
    name: "The Apology Line",
    url: "https://rss.art19.com/apology-line",
  },
  {
    id: 2,
    name: "Crime Junkie",
    url: "https://feeds.megaphone.fm/ADL9840290619",
  },
];
